import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * HTML made safe the way Angular does it for `[innerHTML]`, for the tooltips
 * that show markup (`[tooltipEscape]="false"`).
 */
@Pipe({
  name: 'sanitizeHtml',
  standalone: false,
})
export class SanitizeHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    return this.sanitizer.sanitize(SecurityContext.HTML, String(value)) || '';
  }
}
